import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPhaseData } from '../../data/programData';
import { getEmbedUrl } from '../../data/trainingSessionHelpers';
import { Play, ChevronRight, X } from 'lucide-react';

// Placeholder video data - update with actual videos
const POINTS_TO_PROGRESS_VIDEOS = {
  phase_1: [
    { id: 1, title: 'Overview', videoUrl: 'https://youtu.be/yAiGKZS-5T4' },
    { id: 2, title: 'Session 1 Points', videoUrl: 'https://youtu.be/hgY14_zS9hU' },
    { id: 3, title: 'Session 2 Points', videoUrl: 'https://youtu.be/TWMUBqO1xdwc' },
    { id: 4, title: 'Optional Points', videoUrl: 'https://youtu.be/mqPWA_mmvxg' },
  ],
  phase_2: [
    { id: 1, title: 'Overview', videoUrl: 'https://youtu.be/HEWdqq_DQxM' },
    { id: 2, title: 'Session 1 Points', videoUrl: 'https://youtu.be/z5N5k9HsMw4' },
    { id: 3, title: 'Session 2 Points', videoUrl: 'https://youtu.be/yQ6mVHq_rxg' },
    { id: 4, title: 'Optional Points', videoUrl: 'https://youtu.be/ah7GQUmXI6Y' },
  ],
  phase_3: [
    { id: 1, title: 'Overview', videoUrl: 'https://youtu.be/d02exRx4eYg' },
    { id: 2, title: 'Session 1 Points', videoUrl: 'https://youtu.be/284JY-1ogvw' },
    { id: 3, title: 'Session 2 Points', videoUrl: 'https://youtu.be/5Xx-dmYkY6k' },
    { id: 4, title: 'Optional Points', videoUrl: 'https://youtu.be/VtpecfBrdVQ' },
  ],
  phase_4: [
    { id: 1, title: 'Overview', videoUrl: 'https://youtu.be/hY5b9WDOsJY' },
    { id: 2, title: 'Session 1 Points', videoUrl: 'https://youtu.be/wFPRg1suHos' },
    { id: 3, title: 'Session 2 Points', videoUrl: 'https://youtu.be/MP5iuIlseoA' },
    { id: 4, title: 'Optional Points', videoUrl: 'https://youtu.be/6n3akDzzAhY' },
  ],
};

export function PointsToProgressPage() {
  const { phaseId } = useParams();
  const [activeVideo, setActiveVideo] = useState(null);
  
  const phaseNum = parseInt(phaseId);
  const phaseData = getPhaseData(phaseNum);
  const videos = POINTS_TO_PROGRESS_VIDEOS[`phase_${phaseNum}`] || [];

  return (
    <div className="max-w-2xl mx-auto p-4 pb-24 lg:pb-8">
      <div className="flex items-center mb-6">
        <Play className="h-6 w-6 text-primary mr-2" />
        <h1 className="text-2xl font-bold text-gray-900">
          {phaseData?.title} - Points to Progress
        </h1>
      </div>

      <p className="text-gray-600 mb-6">
        Watch these videos to understand the key exercises and techniques for this phase.
      </p>

      {/* Video List */}
      <div className="space-y-3">
        {videos.map((video) => (
          <button
            key={video.id}
            onClick={() => setActiveVideo(video)}
            className="w-full bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex items-center justify-between hover:shadow-md transition-shadow"
          >
            <div className="flex items-center">
              <div className="h-12 w-12 rounded-full bg-orange-100 flex items-center justify-center mr-4">
                <Play className="h-6 w-6 text-orange-600" />
              </div>
              <span className="font-medium text-gray-900">{video.title}</span>
            </div>
            <ChevronRight className="h-5 w-5 text-gray-400" />
          </button>
        ))}
      </div>

      {videos.length === 0 && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 text-center">
          <p className="text-gray-500">No videos available for this phase yet.</p>
        </div>
      )}

      {/* Video Modal */}
      {activeVideo && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div 
            className="fixed inset-0 bg-black/70"
            onClick={() => setActiveVideo(null)}
          />
          
          <div className="flex min-h-full items-center justify-center p-4">
            <div className="relative bg-white rounded-xl shadow-xl w-full max-w-3xl overflow-hidden">
              <div className="flex items-center justify-between p-4 border-b">
                <h2 className="text-lg font-semibold">{activeVideo.title}</h2>
                <button
                  onClick={() => setActiveVideo(null)}
                  className="p-2 -mr-2 rounded-full hover:bg-gray-100"
                >
                  <X className="h-5 w-5 text-gray-500" />
                </button>
              </div>
              
              <div className="aspect-video bg-gray-900">
                <iframe
                  src={getEmbedUrl(activeVideo.videoUrl)}
                  title={activeVideo.title}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}